<template>
    <div>
        <div id="terms_and_conditions" class="modal-body bg-white border-black border-solid border-2 border-opacity-20">
            <p v-html="terms" class="px-4" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    props: {
        terms: {
            type: String,
            default: 'Loading Terms and Conditions...'
        },
    },
}
</script>
<style scoped>
.hide {
    display: none !important;
}
:deep() p {
    margin: 16px 0 16px !important;
}

:deep() h2 {
    margin: 19px 0 19px !important;
    font-weight: bolder;
}

:deep() a:link {
    color: #0000EE;
    background-color: transparent;
    text-decoration: none;
}

:deep() a:visited {
    color: #551A8B;
    background-color: transparent;
    text-decoration: none;
}

</style>
